import { useCurrencyContext } from '@shared/utils/currency';
import { CurrencyFormat } from '@shared/utils/currency/types';
import { useCallback } from 'react';
import { useTranslation } from '@shared/core';

export const useMinorUnitsToPriceString = () => {
  const currency = useCurrencyContext();
  const { tq } = useTranslation('stationery');
  return useCallback(
    (price: number, { canShowFreeLabel, freeLabel, form = 'auto', precision }: { canShowFreeLabel?: boolean; freeLabel?: string; form?: CurrencyFormat; precision?: number }) => {
      const priceInMajorUnits = price / 100;
      freeLabel = freeLabel ?? tq`FREE`;

      if (canShowFreeLabel && priceInMajorUnits === 0) {
        return freeLabel;
      }

      return currency.formatCurrency(priceInMajorUnits, {
        form,
        precision,
      });
    },
    [currency, tq],
  );
};
